export const obtenerDimensionesDetachedWindow = () => {
    var parametros = "scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no";
    var width = window.innerWidth * 0.8;
    var height = window.innerHeight * 0.8;
    parametros += ",width=" + width;
    parametros += ",height=" + height;
    var left = (window.innerWidth / 2) - (width / 2);
    var top = (screen.height - height) / 2;
    parametros += ",left=" + left;
    parametros += ",top=" + top;
    return parametros
}

